import type { FC, ReactNode } from 'react'

import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'
import { TRIAL_POINTS } from '@/constants/site'

interface TrialPointsProps {
    points?: readonly string[]
    className?: string
}

export const TrialPoints: FC<TrialPointsProps> = ({ points = TRIAL_POINTS, className }): ReactNode => (
    <ul className={cn('flex flex-wrap gap-x-6 gap-y-2 text-sm', className)}>
        {points.map(point => (
            <li key={point} className='inline-flex items-center gap-2'>
                <Check className='size-4 text-tone-ink' strokeWidth={2.5} aria-hidden='true' />
                {point}
            </li>
        ))}
    </ul>
)
